export interface OAuthUser {
  email: string | null
  name: string | null
  timestamp: string | null
}

export const isOAuthUser = (user: unknown): user is OAuthUser =>
  !!user &&
  (user as OAuthUser).email !== undefined &&
  (user as OAuthUser).name !== undefined &&
  (user as OAuthUser).timestamp !== undefined
